"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoachProfileInformation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const card_1 = require("../../molecules/card");
const styled_components_1 = __importDefault(require("styled-components"));
const card_row_divided_1 = require("../../atoms/card-row-divided");
const form_1 = require("../../atoms/form");
const typography_1 = require("../../shared/typography");
const Modal_1 = __importDefault(require("./Modal"));
const hooks_1 = require("../../shared/hooks");
const MobileContainer_1 = require("./MobileContainer");
const renderSetup = (setup) => ((0, jsx_runtime_1.jsx)("div", { "data-row": true, children: (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { "data-cardRow": true, left: (0, jsx_runtime_1.jsx)(typography_1.P, { "data-label": true, children: setup.label }, void 0), right: (0, jsx_runtime_1.jsx)(form_1.Select, { onChange: setup.onChange, options: setup.options, defaultValue: setup.defaultValue, multiple: false }, void 0) }, setup.label) }, setup.label));
const renderChangePasswordRowField = (isMobile, valueTranslation, passwordIndicator, onClick) => {
    if (isMobile)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: passwordIndicator }, void 0);
    return ((0, jsx_runtime_1.jsxs)(Field, { children: [passwordIndicator, (0, jsx_runtime_1.jsx)(typography_1.A, { onClick: onClick, children: valueTranslation }, void 0)] }, void 0));
};
const CoachProfileInformation = ({ translations, coachDetail, settings, version, isModalVisible, toggleShowModal, onSubmit, onLogout, onBack, isOffline, externalLinks }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(MobileContainer_1.MobileContainer, { isMobile: isMobile, toggleShow: toggleShowModal, onLogout: onLogout, translations: translations, onBack: onBack, externalLinks: externalLinks, children: [(0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)(card_1.Card, { header: (0, jsx_runtime_1.jsx)(Header, { children: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: translations.title }, void 0) }, void 0), children: [(0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { "data-label": true, children: translations.name }, void 0), right: (0, jsx_runtime_1.jsx)(typography_1.P, { children: coachDetail.name }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { "data-label": true, children: translations.email }, void 0), right: (0, jsx_runtime_1.jsx)(typography_1.P, { children: coachDetail.email }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { "data-label": true, children: translations.password }, void 0), right: renderChangePasswordRowField(isMobile, translations.changePasswordLink, (0, jsx_runtime_1.jsx)(typography_1.P, { children: "*******" }, void 0), toggleShowModal) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: settings.map(renderSetup) }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: `${translations.version} ${version}` }, void 0) }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(Modal_1.default, { isMobile: isMobile, translations: translations.changePassword, offline: isOffline, onSubmit: onSubmit, toggleShowModal: toggleShowModal, showModal: isModalVisible }, void 0)] }, void 0));
};
exports.CoachProfileInformation = CoachProfileInformation;
const Container = styled_components_1.default.div `
  min-width: 645px;
  width: 100%;

  & > div:first-of-type {
    background-color: ${({ theme }) => theme.colors.whiteBase};
  }

  h2 {
    font-weight: 600;
  }

  p[data-label] {
    color: ${({ theme }) => theme.colors.greyLighten40};
    padding-right: 3rem;

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      padding-right: 1rem;
    }
  }

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: 0;
  }

  a {
    text-decoration: underline;
    text-transform: capitalize;
  }

  div[data-row]:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  }

  div[data-row] select {
    color: ${({ theme }) => theme.colors.greyBase};
  }

  & > div:last-of-type {
    display: flex;
    justify-content: center;
    margin-top: ${({ theme }) => theme.spacings.xl};
  }

  & > div:last-of-type p:first-letter {
    text-transform: capitalize;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    min-width: unset;
    width: 100%;
  }
`;
const Header = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: space-between;

  h2 {
    margin-bottom: 0;
  }

  p {
    color: ${({ theme }) => theme.colors.greyLighten70};
    font-size: 0.875rem;
  }
`;
const Field = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=CoachProfileInformation.js.map